import * as React from 'react';
import './index.css';

type PropsFunc = (...args: any[]) => any;
interface IProps {
  onMaskClick?: PropsFunc;
  onOK?: PropsFunc;
  btnText?: string;
  title?: string;
  subTitle?: string;
}
export default class BottomDialog extends React.PureComponent<IProps, any> {
  onMaskClick = () => {
    const { onMaskClick } = this.props;
    onMaskClick && onMaskClick();
  };
  noop = () => {};
  onOK = () => {
    const { onOK } = this.props;
    onOK && onOK();
  };
  render() {
    const { title, subTitle, btnText } = this.props;
    return (
      <modal>
        <view className="bottom-dialog-mask" onClick={this.onMaskClick}>
          <view className="bottom-dialog-content content-animation" onClick={this.noop}>
            <view className="platform-content">
              <view className="platform-content-top">
                <text content={title} className="platform-title" />
                <text content={subTitle} className="platform-desc" />
              </view>
              <view className="platform-content-bottom">
                <text content={btnText} className="primary-btn" onClick={this.onOK} />
              </view>
            </view>
          </view>
        </view>
      </modal>
    );
  }
}
